import { FC, useRef } from 'react';

import { getAuctionEditUrl } from 'utils/auction';
import { CampaignProductType } from 'utils/constants/campaign';

import { Link, Text, TooltipHover, VSpacingContainer } from '@hh.ru/magritte-ui';
import { Link as SPALink } from '@hh.ru/redux-spa-middleware';

import useTrls from 'hooks/translation/useTrls';

import { CampaignPromotionLink } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignName/components/CampaignPromotionLink';
import { CampaignStatus } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignName/components/CampaignStatus';

import { DashboardCampaign } from 'store/models/campaignsDashboard';

interface CampaignNameProps {
    campaign: DashboardCampaign;
    isInsufficientBalance: boolean;
    isMobile?: boolean;
}

const TrlKeys = {
    id: 'CampaignsDashboard.CampaignsTable.CampaignName.id',
};

export const CampaignName: FC<CampaignNameProps> = ({ campaign, isInsufficientBalance, isMobile = false }) => {
    const { name: campaignName, vacancyName, productType, id: campaignId, vacancyId } = campaign;

    const activatorRef = useRef<HTMLDivElement>(null);
    const trls = useTrls();

    const campaignNameText = productType === CampaignProductType.SearchAuction ? vacancyName : campaignName;

    const editLink = {
        [CampaignProductType.Cpc]: `/new/campaign/${campaignId}`,
        [CampaignProductType.SearchAuction]: getAuctionEditUrl(vacancyId),
        [CampaignProductType.Vr]: '',
    };

    return (
        <>
            <VSpacingContainer default={4}>
                <Link Element={SPALink} to={editLink[productType]} inline style="neutral" mode="primary">
                    <Text maxLines={1} typography="subtitle-1-semibold">
                        <span ref={activatorRef}>{campaignNameText}</span>
                    </Text>
                </Link>
                <CampaignPromotionLink campaign={campaign} isMobile={isMobile} />
                <CampaignStatus campaign={campaign} isInsufficientBalance={isInsufficientBalance} />
            </VSpacingContainer>
            {!isMobile && (
                <TooltipHover delay={1000} activatorRef={activatorRef} placement="top-center">
                    {campaignNameText}
                    <Text typography="paragraph-3-regular">{trls(TrlKeys.id, [campaignId])}</Text>
                </TooltipHover>
            )}
        </>
    );
};
